export default {
  isOpen: state => state.open,
  viewMode: state => state.viewMode
};
